const state = {
    donations: {}
}
const getters = {
    getDonations (state) {
        return state.donations
    }
}
const mutations = {
    SET_DONATIONS (state, payload) {
        state.donations = payload
    }
}
const actions = {
   setDonations ({commit}, payload) {
       commit('SET_DONATIONS', payload)
   }
}

export default {
    state,
    mutations,
    actions,
    getters
  }